import {
  createMessagesOfferModel,
  IEnrichedChatSchema,
  IErrorResponseSchema,
  IMessagesRequestSchema,
} from '@cian/api-models/chats/v1/messages/offer';
import { IHttpApi } from '@cian/http-api';

export function sendFirstMessage(httpApi: IHttpApi) {
  return (parameters: IMessagesRequestSchema) =>
    httpApi.fetch(createMessagesOfferModel({ hostType: 'ud-api', parameters }))
      .then(({ response, statusCode }) => {
        if (statusCode === 400) {
          throw response as IErrorResponseSchema;
        }

        return response as IEnrichedChatSchema;
      });
}
